import React from 'react';
import { useIntl } from 'react-intl';

import { TranslationKeys } from 'app/translations';
import { EndOfEmploymentReasonEnum } from '../types/employee.types';

export const useEndOfEmploymentReasonSelectItems = () => {
  const intl = useIntl();

  const endOfEmploymentReasonSelectItems = React.useMemo(() => {
    return [
      {
        value: EndOfEmploymentReasonEnum.Vut,
        label: intl.formatMessage({ id: TranslationKeys.global_endOfEmploymentReason_vut }),
        element: intl.formatMessage({ id: TranslationKeys.global_endOfEmploymentReason_vut }),
      },
      {
        value: EndOfEmploymentReasonEnum.AowPension,
        label: intl.formatMessage({ id: TranslationKeys.global_endOfEmploymentReason_aowPension }),
        element: intl.formatMessage({ id: TranslationKeys.global_endOfEmploymentReason_aowPension }),
      },
      {
        value: EndOfEmploymentReasonEnum.Death,
        label: intl.formatMessage({ id: TranslationKeys.global_endOfEmploymentReason_death }),
        element: intl.formatMessage({ id: TranslationKeys.global_endOfEmploymentReason_death }),
      },
      {
        value: EndOfEmploymentReasonEnum.NewEmployer,
        label: intl.formatMessage({ id: TranslationKeys.global_endOfEmploymentReason_newEmployer }),
        element: intl.formatMessage({ id: TranslationKeys.global_endOfEmploymentReason_newEmployer }),
      },
      {
        value: EndOfEmploymentReasonEnum.EstablishmentAsAnIndependentEntrepreneur,
        label: intl.formatMessage({
          id: TranslationKeys.global_endOfEmploymentReason_establishmentAsAnIndependentEntrepreneur,
        }),
        element: intl.formatMessage({
          id: TranslationKeys.global_endOfEmploymentReason_establishmentAsAnIndependentEntrepreneur,
        }),
      },
      {
        value: EndOfEmploymentReasonEnum.RedundancyScheme,
        label: intl.formatMessage({ id: TranslationKeys.global_endOfEmploymentReason_redundancyScheme }),
        element: intl.formatMessage({ id: TranslationKeys.global_endOfEmploymentReason_redundancyScheme }),
      },
      {
        value: EndOfEmploymentReasonEnum.Dismissal,
        label: intl.formatMessage({ id: TranslationKeys.global_endOfEmploymentReason_dismissal }),
        element: intl.formatMessage({ id: TranslationKeys.global_endOfEmploymentReason_dismissal }),
      },
      {
        value: EndOfEmploymentReasonEnum.WaoWia,
        label: intl.formatMessage({ id: TranslationKeys.global_endOfEmploymentReason_waoWia }),
        element: intl.formatMessage({ id: TranslationKeys.global_endOfEmploymentReason_waoWia }),
      },
      {
        value: EndOfEmploymentReasonEnum.EndOfContractForADefinitePeriod,
        label: intl.formatMessage({ id: TranslationKeys.global_endOfEmploymentReason_endOfContractForADefinitePeriod }),
        element: intl.formatMessage({
          id: TranslationKeys.global_endOfEmploymentReason_endOfContractForADefinitePeriod,
        }),
      },
      {
        value: EndOfEmploymentReasonEnum.Other,
        label: intl.formatMessage({ id: TranslationKeys.global_endOfEmploymentReason_other }),
        element: intl.formatMessage({ id: TranslationKeys.global_endOfEmploymentReason_other }),
      },
    ];
  }, [intl]);

  const getEndOfEmploymentReasonDisplayNameByValue = React.useCallback(
    (value: EndOfEmploymentReasonEnum) => {
      return endOfEmploymentReasonSelectItems.find(item => item.value === value)?.label ?? '';
    },
    [endOfEmploymentReasonSelectItems],
  );

  return { endOfEmploymentReasonSelectItems, getEndOfEmploymentReasonDisplayNameByValue };
};
